import React, { useState, useEffect } from 'react';

// Lightweight rAF-based FPS readout with a built-in show/hide switch
// (for a clean presentation view).
export default function FPSMeter() {
  const [fps, setFps] = useState(0);
  const [show, setShow] = useState(true);
  useEffect(() => {
    let raf, last = performance.now(), frames = 0, acc = 0;
    const loop = (t) => {
      frames++; acc += t - last; last = t;
      if (acc >= 500) { setFps(Math.round((frames * 1000) / acc)); frames = 0; acc = 0; }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, []);
  const color = fps >= 85 ? '#34d399' : fps >= 55 ? '#fbbf24' : '#f87171';
  return (
    <div className="flex items-center gap-1.5">
      {show && (
        <div
          data-testid="fps-meter"
          className="font-mono text-[10px] font-bold px-2 py-1 rounded-md"
          style={{ color, background: 'rgba(0,0,0,0.45)', border: '1px solid rgba(255,255,255,0.12)' }}
        >
          {fps} FPS
        </div>
      )}
      <button
        data-testid="fps-toggle"
        onClick={() => setShow((s) => !s)}
        title={show ? 'Hide FPS meter' : 'Show FPS meter'}
        className="w-6 h-6 flex items-center justify-center rounded-md border border-white/15 text-white/45 hover:text-gold hover:border-gold/40 transition-colors font-mono text-[11px]"
        style={{ background: 'rgba(0,0,0,0.35)' }}
      >
        {show ? '×' : '⌁'}
      </button>
    </div>
  );
}
